import { render, staticRenderFns } from "./IndicatorShift.vue?vue&type=template&id=6f8480d7&scoped=true"
import script from "./IndicatorShift.vue?vue&type=script&lang=js"
export * from "./IndicatorShift.vue?vue&type=script&lang=js"
import style0 from "./IndicatorShift.vue?vue&type=style&index=0&id=6f8480d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8480d7",
  null
  
)

export default component.exports